<template>

<div>
    
    <div class="app-main flex-column flex-row-fluid">
		<div class="d-flex flex-column flex-column-fluid">
			<div class="app-toolbar py-3 py-lg-6">
				<div class="app-container container-xxl d-flex flex-stack">
					<div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
						<h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Setari Cont</h1>
						<ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
							<li class="breadcrumb-item text-muted">
								<a class="text-muted text-hover-primary" @click="$router.go(-1)" style="cursor: pointer;">Inapoi</a>
							</li>
							<li class="breadcrumb-item">
								<span class="bullet bg-gray-400 w-5px h-2px"></span>
							</li>
							<li class="breadcrumb-item text-muted">Setari Cont</li>
						</ul>
					</div>

				</div>
			</div>
			<div class="app-content flex-column-fluid">
				<div id="kt_app_content_container" class="app-container container-xxl">
					<div class="card mb-5 mb-xl-10">
						<div class="card-body pt-9 pb-0">
							<div class="d-flex flex-wrap flex-sm-nowrap">
								<div class="flex-grow-1">
									<div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
										<div class="d-flex flex-column">
											<div class="d-flex align-items-center mb-2">
												<a href="#" class="text-gray-900 text-hover-primary fs-2 fw-bold me-1">{{form_setari_cont.nume}} {{form_setari_cont.prenume}}</a>
												<a href="#">
													<i class="ki-duotone ki-verify fs-1 text-primary">
														<span class="path1"></span>
														<span class="path2"></span>
													</i>
												</a>
											</div>
											<div class="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2">
												<a class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
													<i class="ki-duotone ki-profile-circle fs-4 me-1">
														<span class="path1"></span>
														<span class="path2"></span>
														<span class="path3"></span>
													</i>
													<div class="badge badge-success" v-if="form_setari_cont.tip_cont == 1">Utilizator</div>
													<div class="badge badge-primary" v-if="cont.u_tip_cont == 2">Tip Cont2</div>
													<div class="badge badge-info" v-if="cont.u_tip_cont == 3">Tip Cont3</div>
													<div class="badge badge-warning" v-if="cont.u_tip_cont == 991">Administrator</div>
													<div class="badge badge-dark" v-if="form_setari_cont.tip_cont == 996">WebDev</div>
												</a>
												<a class="d-flex align-items-center text-gray-400 text-hover-primary mb-2">
													<i class="ki-duotone ki-sms fs-4">
														<span class="path1"></span>
														<span class="path2"></span>
													</i>
												    {{ form_setari_cont.email }}
												</a>
											</div>
										</div>
									</div>
									<div class="d-flex flex-wrap flex-stack">
										<div class="d-flex flex-column flex-grow-1 pe-8">
											<div class="d-flex flex-wrap" >
                                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" >
													<div class="d-flex align-items-center">
														<i class="ki-duotone ki-tag fs-2x text-success me-2">
															<span class="path1"></span>
															<span class="path2"></span>
															<span class="path3"></span>
														</i>
														<div class="fs-2 fw-bold" data-kt-countup="true" :data-kt-countup-value="numar_firme ?? 0">0</div>
													</div>
													<div class="fw-semibold fs-6 text-gray-400">Firme</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
								<li class="nav-item mt-2">
									<a class="nav-link text-active-primary ms-0 me-10 py-5 active" data-bs-toggle="tab" href="#setari_cont">Setari Cont</a>
								</li>
								<li class="nav-item mt-2" v-if="this.$gate.isAdmin() || this.$gate.isWebDev()">
									<a class="nav-link text-active-primary ms-0 me-10 py-5" data-bs-toggle="tab" href="#setari">Setari</a>
								</li>
								<li class="nav-item mt-2">
									<a class="nav-link text-active-primary ms-0 me-10 py-5" @click="logOut()" style="cursor: pointer; color: red;">Deconectare</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="tab-content">
						<div class="tab-pane fade show active" id="setari_cont" role="tabpanel">
							<div class="card mb-5 mb-xl-10">
								<div class="card-header">
									<div class="card-title m-0">
										<h3 class="fw-bold m-0">Detalii Profil</h3>
									</div>
									<a @click="modalEditareInformatiiProfil(informatii_profil)" class="btn btn-sm btn-primary align-self-center">Editeaza Profilul</a>

								</div>
								<div class="card-body p-9">
									<div>
                                        <div class="row mb-6">
                                            <label class="col-lg-4 col-form-label required fw-semibold fs-6">Email</label>
                                            <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                <input type="email" name="email" v-model="form_setari_cont.email" class="form-control" placeholder="E-Mail"/>
                                            </div>
                                        </div>
                                        <div class="row mb-6">
                                            <label class="col-lg-4 col-form-label required fw-semibold fs-6">Nume Complet</label>
                                            <div class="col-lg-8">
                                                <div class="row">
                                                    <div class="col-lg-6 fv-row fv-plugins-icon-container">
                                                        <input type="text" name="nume" v-model="form_setari_cont.nume" class="form-control form-control-lg mb-3 mb-lg-0" placeholder="Nume">
                                                    <div class="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div></div>
                                                    <div class="col-lg-6 fv-row fv-plugins-icon-container">
                                                        <input type="text" name="prenume" v-model="form_setari_cont.prenume" class="form-control form-control-lg mb-3 mb-lg-0" placeholder="Prenume">
                                                    <div class="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-6">
                                            <label class="col-lg-4 col-form-label required fw-semibold fs-6">CNP</label>
                                            <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                <input type="text" name="cnp" v-model="form_setari_cont.cnp" class="form-control" placeholder="CNP"/>
                                            </div>
                                        </div>
                                        <div class="row mb-6">
                                            <label class="col-lg-4 col-form-label fw-semibold fs-6">Telefon</label>
                                            <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                <input type="text" v-model="form_setari_cont.telefon" class="form-control" placeholder="07XXXXXXXX" />
                                            </div>
                                        </div>

                                        <div class="row mb-6">
                                            <label class="col-lg-4 col-form-label fw-semibold fs-6">Firmă Autologin</label>
                                            <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                <input type="text"  class="form-control" placeholder="Dezactivat temporar" disabled/>
                                            </div>
                                        </div>

                                        <div class="row mb-6">
                                            <label class="col-lg-4 col-form-label fw-semibold fs-6">Newsletter</label>
                                            <div class="col-lg-8 fv-row">
                                                <div class="form-check form-switch form-check-custom form-check-solid">
                                                <input class="form-check-input" type="checkbox" v-model="form_setari_cont.newsletter" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mb-6">
                                            <label class="col-lg-4 col-form-label fw-semibold fs-6">Cont activ</label>
                                            <div class="col-lg-8 fv-row">
                                                <div class="form-check form-switch form-check-custom form-check-solid">
                                                <input class="form-check-input" type="checkbox" v-model="form_setari_cont.activ" disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mb-6">
                                            <label class="col-lg-4 col-form-label fw-semibold fs-6">Email verificat</label>
                                            <div class="col-lg-8 fv-row">
                                                <div class="form-check form-switch form-check-custom form-check-solid">
                                                <input class="form-check-input" type="checkbox" v-model="form_setari_cont.is_email_verified" disabled/>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mb-0">
                                            <label class="col-lg-4 col-form-label required fw-semibold fs-6">Communication</label>
                                            <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                <div class="d-flex align-items-center mt-3">
                                                    <label class="form-check form-check-custom form-check-inline form-check-solid me-5">
                                                        <input class="form-check-input" name="communication[]" type="checkbox" value="1">
                                                        <span class="fw-semibold ps-2 fs-6">Email</span>
                                                    </label>
                                                    <label class="form-check form-check-custom form-check-inline form-check-solid">
                                                        <input class="form-check-input" name="communication[]" type="checkbox" value="2">
                                                        <span class="fw-semibold ps-2 fs-6">Phone</span>
                                                    </label>
                                                </div>
                                                <div class="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                            </div>
                                        </div>
									</div>
								</div>
							</div>
						</div>
						<div class="tab-pane fade" id="setari" role="tabpanel">
							TBE
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>


</div>
    <!-- /.row -->
</template>
  
<script>
   
  export default {
    data () {
      return {
		tari: [],
		orase: [],
		cont: '',
		informatii_profil: '',
        editmode: false,
        numar_firme: '',
		info_comanda: {
			"comanda": {
				c_awb: '',
				c_data_deschidere: '',
				c_id: '',
				c_platit: '',
				c_total: '',
				c_updated_at: '',
				df_pf_adresa: '',
				df_pf_cnp: '',
				df_pf_judet: '',
				df_pf_localitate: '',
				df_pf_nume_prenume: '',
				df_pf_telefon: '',
				df_pj: '',
				df_pj_banca: '',
				df_pj_cont: '',
				df_pj_cui: '',
				df_pj_cui_prefix: '',
				df_pj_j: '',
				df_pj_j_an: '',
				df_pj_j_data: '',
				df_pj_j_nr: '',
				df_pj_nume_companie: '',
				df_pj_sediu_adresa: '',
				df_pj_sediu_judet: '',
				df_pj_sediu_localitate: '',
				df_pj_telefon: '',
				dl_adresa: '',
				dl_judet: '',
				dl_localitate: '',
				dl_nume_contact: '',
				dl_telefon: '',
				ml_denumire: '',
				mp_denumire: '',
				sc_denumire: '',
				u_email: '',
			}
		},

		setari_select2_informatii_profil: {
			theme: 'bootstrap-5',
			selectionCssClass: 'select2--large',
    		dropdownCssClass: 'select2--large',
			placeholder: this.$t('select.selecteaza_din_lista'),
			width: "200px",
		},

        form_setari_cont: Form.make({
            id: '',
            email: '',
            nume: '',
            prenume: '',
            tip_cont: '',
            cnp: '',
            telefon: '',
            autologin_firma: '',
            newsletter: false,
            activ: true,

        }),
      }
    },
    mounted(){
		//console.log();
    },
    methods:{
        getResults(pagina = 1) {
            axios.get('/profil/incarcaCont?page=' + pagina)
                .then(response => {
                    this.comenzi = response.data.comenzi;
                });
        },
        incarcaCont(){ 
            axios.get("/api/cont/incarcaInfoCont")
            .then((response)=>{
                const user = response.data.user;

                user.newsletter = user.newsletter == 1 ? true : false;
                user.activ = user.activ == 1 ? true : false;
                user.is_email_verified = user.is_email_verified == 1 ? true : false;

                this.numar_firme = response.data.numar_firme;
                this.form_setari_cont.fill(user);
            })
            .catch(()=>{
            	console.log('[CONT] A aparut o eroare la incarcarea profilului.');
            })
        },
        /*
        modalAdaugareAdresa(){
            this.editmode = false;
            this.form_adresa.reset();
            $('#AdreseModal').modal('show');
        },
		vizualizareComandaModal(id){
			this.incarcaInfoComanda(id)
            $('#InformatiiComandaModal').modal('show');
        },
		incarcaInfoComanda(id){
            axios.get("/comanda/vizualizare/"+id).then((response) => {
                this.info_comanda = response.data;
            });
        },
		modalAdaugareInformatiiProfil(){
            this.editmode = false;
            this.form_adauga_profil.reset();
			this.incarcaTari();
            $('#InformatiiProfilModal').modal('show');
        },
		modalEditareInformatiiProfil(id){
            this.editmode = true;
            this.form_adauga_profil.reset();
            this.form_adauga_profil.fill(id);
			this.form_adauga_profil.id_tara = this.form_adauga_profil.id_tara.toString();
			this.form_adauga_profil.id_oras = this.form_adauga_profil.id_oras.toString();
			this.incarcaTari();
			this.incarcaOraseEdit(id.id_tara);
            $('#InformatiiProfilModal').modal('show');
        },
        modalEditeazaAdresa(id){
            this.editmode = true;
            this.form_adresa.reset();
            this.form_adresa.fill(id);
            $('#AdreseModal').modal('show');
            if(this.adresa_livrare_preferata === this.form_adresa.id)
            {
                this.form_adresa.adresa_favorita = 1;
            }
        },
        incarcaAdreseLivrare(){
            axios.get("/cont/AdrLivrare").then((response) => {
                this.adrese_livrare = response.data.date_livrare;
                this.adresa_livrare_preferata = response.data.adresa_livrare_preferata;
            });
        },
		incarcaTari(){
            axios.get("/module/iaTari").then((response) => {
                this.tari = response.data;
            });
        },
		incarcaOrase(event){
            axios.get("/module/iaOrase/"+event.id).then((response) => {
                this.orase = response.data;
            });
        },
		incarcaOraseEdit(id){
            axios.get("/module/iaOrase/"+id).then((response) => {
                this.orase = response.data;
            });
        },
        logOut(){
           axios.post("/logout").then((response) => {
               window.location.replace('/');
           });
        },
        StergeAdresa(id)
        {
            swal.fire({
            title: 'Sunteți sigur?',
            text: "Odată ștearsă adresa nu mai poate fi recuperată",
            type: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#3085d6',
            confirmButtonColor: '#d33',
            confirmButtonText: 'Sterge!'
            }).then((result) => {
                // Request to the server.
                if (result.value) {
                    this.form_adresa.delete('/cont/AdrLivrare/'+id).then(()=>{
                        swal.fire(
                        'Adresă ștearsa!',
                        'Adresa a fost stearsa.',
                        'success'
                        )
                        emitter.emit('AdresaLivrareUpdate');
                    }).catch(()=>{
                    swal("Eroare!", "A aparut o eroare.", "warning");
                    })
                }
            })
        },
        adaugaAdresa(){
            this.form_adresa.post('/cont/AdrLivrare')
            .then((response)=>{
                $('#AdreseModal').modal('hide');
                Updateds.$emit('AdresaLivrareUpdate');
            })
            .catch(()=>{
                console.log('Eroare la adaugarea adresei!');

            })
        },
        actualizeazaAdresa(id){
            this.form_adresa.put('/cont/AdrLivrare/'+id)
            .then(()=>{
                $('#AdreseModal').modal('hide');
                swal.fire(
                    'Adresă actualizată!',
                    'Informațiile au fost modificate.',
                    'success'
                )
                emitter.emit('AdresaLivrareUpdate');
            })
            .catch(()=>{
                console.log('Eroare la actualizarea adresei.')
            });
        },
        modalAdaugareAdresaFacturare(){
            this.editmode = false;
            this.form_adauga_profil.reset();
            $('#AdreseFacturareModal').modal('show');
        },
        modalEditeazaAdresaFacturare(id){
            this.editmode = true;
            this.form_adauga_profil.reset();
            this.form_adauga_profil.fill(id);
            $('#AdreseFacturareModal').modal('show');
            if(this.adresa_facturare_preferata === this.form_adauga_profil.id)
            {
                this.form_adauga_profil.adresa_favorita = 1;
            }
        },
        incarcaAdreseFacturare(){
            axios.get("/cont/AdrFacturare").then((response) => {
                this.adrese_facturare = response.data.date_facturare;
                this.adresa_facturare_preferata = response.data.adresa_facturare_preferata;
            });
        },
        StergeAdresaFacturare(id)
        {
            swal.fire({
            title: 'Sunteți sigur?',
            text: "Odată ștearsă adresa nu mai poate fi recuperată",
            type: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#3085d6',
            confirmButtonColor: '#d33',
            confirmButtonText: 'Sterge!'
            }).then((result) => {
                // Request to the server.
                if (result.value) {
                    this.form_adauga_profil.delete('/cont/AdrFacturare/'+id).then(()=>{
                        swal.fire(
                        'Adresă ștearsa!',
                        'Adresa de facturare a fost stearsa.',
                        'success'
                        )
                        Updateds.$emit('AdresaFacturareUpdate');
                    }).catch(()=>{
                    swal("Eroare!", "A aparut o eroare.", "warning");
                    })
                }
            })
        },
        adaugaInformatiiProfil(){
            this.form_adauga_profil.post('/profil/adaugaProfil')
            .then((response)=>{
                $('#InformatiiProfilModal').modal('hide');
				toast.fire({
                    position: "top-end",
                    icon: 'success',
                    title: 'Informatiile au fost trimise catre validare!',
                    showConfirmButton: false,
                    timer: 2000
                })
                emitter.emit('InformatiiProfilUpdate');
            })
            .catch(()=>{
                console.log('Eroare la adaugarea profilului!');

            })
        },
		editeazaInformatiiProfil(id){
            this.form_adauga_profil.post('/profil/editeazaProfil/'+id)
            .then((response)=>{
				console.log(this.form_adauga_profil);
                $('#InformatiiProfilModal').modal('hide');
				toast.fire({
                    position: "top-end",
                    icon: 'success',
                    title: 'Trimis actualizate au fost trimise catre validare!',
                    showConfirmButton: false,
                    timer: 2000
                })
                emitter.emit('InformatiiProfilUpdate');
            })
            .catch(()=>{
                console.log('Eroare la adaugarea profilului!');

            })
        },
        actualizeazaAdresaFacturare(id){
            this.form_adauga_profil.put('/cont/AdrFacturare/'+id)
            .then(()=>{
                $('#AdreseFacturareModal').modal('hide');
                swal.fire(
                    'Adresă actualizată!',
                    'Informațiile au fost modificate.',
                    'success'
                )
                Updateds.$emit('AdresaFacturareUpdate');
            })
            .catch(()=>{
                console.log('Eroare la actualizarea adresei de facturare.')
            });
        },*/
    },
	computed: {

        },
    created() {

        this.incarcaCont();

        emitter.on('InformatiiProfilUpdate',() => { 
            this.incarcaCont();
        });

        emitter.on('AdresaFacturareUpdate',() => { 
            this.incarcaAdreseFacturare();
        });

    }
  } 
  </script>
  
  <style lang="scss" scoped>
    .icon-mare-24 {
        font-size: 24px
    }
    .icon-mare-20 {
        font-size: 20px
    }

    .form-control {
    font-size: 1.3rem;
    line-height: 2;
    }
    .input-group-text {
        font-size: 1.3rem;
        line-height: 2;
    }
    .account__details--title {
        position: absolute;
        padding-left: 30%;
    }
  </style>
  